import { useQuery } from '@tanstack/react-query';

import { CompanySettings } from '@/types/company-settings';
import { CompanySettingValue, getCompanySettings } from './api';
import { COMPANY_SETTINGS } from './query-keys';

export const useGetCompanySettings = (id: string | undefined) => {
  return useQuery({
    queryKey: [COMPANY_SETTINGS, id],
    queryFn: () => getCompanySettings({ id }),
    select: (companySettings): CompanySettings => {
      const parsedCompanySettings: Record<string, CompanySettingValue> = {};

      for (const currentKeyValue of companySettings) {
        if (!currentKeyValue) continue;

        parsedCompanySettings[currentKeyValue.key] = currentKeyValue.value;
      }

      return parsedCompanySettings as CompanySettings;
    },
    retry: false,
    enabled: Boolean(id)
  });
};
